import React, { useEffect, useState, memo } from 'react';
import { useMEMTranslation } from '../../utils/text-utils';
import { useTrackInteraction } from '../../services/logging/hooks';
import { usePageContext } from '../../utils/page-context';
import { useAvailableManagerPartitions } from './hooks';
import { Option, Combobox } from '../../providers/harmony-scope/lazy-enablers';
import { getDefaultPartition } from '../../ducks/filters/utils-filters';
import { useMonthDayYear } from '../../utils/date-utils';
import { EPartitionCadence, TPartition } from '../../ducks/filters/types-filters';

interface IProps {
  selectedParticipation: string;
  selectedManagerCadence: EPartitionCadence;
  selectedPartitionGroupName: string;
  selectedPartition: string;
  onChange: (partitionCadence: string) => void;
}

const formatPartition = (monthDayYear: (date: Date | string) => string, partition: TPartition) =>
  partition && `${partition.title} (${monthDayYear(partition.startDate)} - ${monthDayYear(partition.endDate)})`;

const componentName = 'Manager Partition Picker Filters Panel';
export const ComponentFilterManagerPartition = memo((props: IProps) => {
  // Props Accessors
  const {
    selectedManagerCadence,
    selectedParticipation: selectedParticipationProp,
    selectedPartitionGroupName: selectedPartitionGroupNameProp,
    selectedPartition: selectedPartitionProp,
    onChange,
  } = props;

  // Hooks
  const monthDayYear = useMonthDayYear();
  const { t } = useMEMTranslation();
  const pageName = usePageContext();
  const trackInteraction = useTrackInteraction();
  const availablePartitions = useAvailableManagerPartitions(selectedPartitionGroupNameProp, selectedManagerCadence);
  const [selectedPartition, setSelectedPartition] = useState(selectedPartitionProp);

  // Effects
  useEffect(() => {
    const defaultPartition = getDefaultPartition(availablePartitions);
    if (!defaultPartition) return;
    setSelectedPartition(defaultPartition.title);
  }, [availablePartitions, selectedParticipationProp]);

  useEffect(() => {
    onChange(selectedPartition);
  }, [onChange, selectedPartition]);

  useEffect(() => {
    setSelectedPartition(selectedPartitionProp);
  }, [selectedPartitionProp]);

  // Handlers
  const partitionChanged = (event: any) => {
    if (!event.target.value) return;
    const newPartition = event.target.value;
    trackInteraction('Selected manager partition', pageName, componentName, {
      selectedManagerPartition: newPartition,
    });
    setSelectedPartition(newPartition);
  };

  return (
    <>
      <Combobox label={t('filtersPanelTimePeriodLabel')} value={selectedPartition} onHeChange={partitionChanged}>
        {availablePartitions.map((p) => (
          <Option key={p.title} value={p.title} title={p.title}>
            {`${formatPartition(monthDayYear, p)}`}
          </Option>
        ))}
      </Combobox>
      <br />
    </>
  );
});
